import React from 'react';
import { Checkbox } from 'semantic-ui-react';
import FormFieldWrapper from '@plone/volto/components/manage/Widgets/FormFieldWrapper';

interface ToggleWidgetProps {
  id: string;
  title: string;
  value?: boolean;
  onChange?: (id: string, value: boolean) => void;
  isDisabled?: boolean;
}

/**
 * Campo booleano no formato de chave liga/desliga.
 *
 * Mesmo contrato do `CheckboxWidget` do core — de onde saiu a estrutura —, só
 * que com a variante `toggle` do Semantic. A caixa de seleção do core não
 * comunica bem "ligado/desligado" para uma opção que muda o comportamento da
 * página; a chave, sim.
 *
 * Uso no schema:
 *
 * ```ts
 * autoplay: { title: 'Passar sozinho', type: 'boolean', widget: 'toggle' }
 * ```
 */
const ToggleWidget: React.FC<ToggleWidgetProps> = (props) => {
  const { id, title, value, onChange, isDisabled } = props;

  return (
    <FormFieldWrapper {...props} columns={1}>
      <div className="wrapper">
        <Checkbox
          toggle
          id={`field-${id}`}
          name={`field-${id}`}
          checked={value || false}
          disabled={isDisabled}
          onChange={(_event, { checked }) => onChange?.(id, !!checked)}
          label={<label htmlFor={`field-${id}`}>{title}</label>}
        />
      </div>
    </FormFieldWrapper>
  );
};

export default ToggleWidget;
